import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/useRedux";
import { selectCurrentToken } from "../redux/reducers/auth";

const PrivateOutlet = () => {
  const token = useAppSelector(selectCurrentToken);
  const location = useLocation();
  return token ? <Outlet /> : <Navigate to="login" state={{ from: location }} replace />;
};

export default PrivateOutlet;
